export default __webpack_public_path__ + "image/innovation-diagram.svg";